export default {
  'cdnResources.list.deleteCdn.message': 'Delete succeeded',
  'cdnResources.list.columns.Tag.suspend': 'suspend',
  'cdnResources.list.Popconfirm.title': 'Are you sure delete this CDN Resource?',
  'cdnResources.list.Popconfirm.okText': 'Yes',
  'cdnResources.list.Popconfirm.cancelText': 'No',
  'cdnResources.list.Modal.Cancel': 'Cancel',
  'cdnResources.list.title': 'CDN Resource',
  'cdnResources.list.Create': 'Create new CDN resource',
  'cdnResources.list.Create.ResourceName': 'Resource name',
  'cdnResources.list.Create.Disabled': 'Reached the upper limit',
  //v1.2.0
  'cdnResources.list.ConfirmAndCreate': 'Confirm and create',
  'cdnResources.list.Empty.btnText': 'Get Started',
  'cdnResources.list.Empty.desc': 'Speed up within 3 minutes',
  'cdnResources.list.columns.title1': 'CDN hostname',
  'cdnResources.list.columns.title2': 'CNAME',
  'cdnResources.list.columns.title3': 'Origin',
  'cdnResources.list.columns.title4': 'Options',
  'cdnResources.list.columns.title7': 'Origin type',
  //v1.2.0
  'cdnResources.list.columns.title5': 'Tier',
  'cdnResources.list.columns.title6': 'Usage this month',
  'cdnResources.list.PopoverText1': 'Data details',
  'cdnResources.list.PopoverText2': 'Settings',
  'cdnResources.list.PopoverText3': 'Delete resources',
  'cdnResources.list.PopoverText4': 'Purge all files',
  //v1.3.3
  'cdnResources.create.stepBox.step0': 'Fill in your resource details',
  'cdnResources.create.stepBox.step1': 'Choose your tier',
  'cdnResources.create.step0.title1': 'Create CDN resources',
  'cdnResources.create.step0.title2': 'Origin',
  'cdnResources.create.step0.type1': 'Origin URL',
  'cdnResources.create.step0.type2': 'Object storage',
  'cdnResources.create.step0.sourceHostName': 'Origin server hostname',
  'cdnResources.create.step0.sourceHostName.text':
    'The origin server hostname determines which domain the origin server receives in requests. The default type is provided as a reference only. ',
  'cdnResources.create.step0.btn': 'Choose your tier',

  'cdnResources.create.step1.fristFree': 'First {val} free',
  // 'cdnResources.create.stepBox.step1': 'Basic Settings',
  'cdnResources.create.stepBox.step2': 'Completed',
  'cdnResources.create.onSubmit.message': 'Created succeeded',
  'cdnResources.create.step1.validatorCdnHostName.same': 'CDN hostname and Origin are the same',
  'cdnResources.create.step1.Form.cdnHostName.name': 'CDN hostnames',
  'cdnResources.create.step1.Form.cdnHostName.message': 'Please input your CDN hostnames!',
  'cdnResources.create.step1.Form.origin.protocol': 'Origin protocol',
  'cdnResources.create.step1.Form.origin.name': 'Origin',
  'cdnResources.create.step1.Form.origin.message': 'Please input Origin!',
  'cdnResources.create.step1.Form.Checkbox.name': 'Use custom port',
  'cdnResources.create.step1.Form.port.name': 'port(optional)',
  'cdnResources.create.step1.Form.port.message': 'Please input Port!',
  'cdnResources.create.step1.Form.port.80':
    '80 is usually an HTTP protocol port. Please confirm if the origin protocol selection is correct.',
  'cdnResources.create.step1.Form.port.443':
    '443 is usually an HTTPS protocol port. Please confirm if the origin protocol selection is correct.',
  'cdnResources.create.step2.message': 'Create succeeded',
  'cdnResources.create.step2.title1':
    'CDN Resource was sucessfully created and CNAME will be available in ',
  'cdnResources.create.step2.title2': 'seconds',

  'cdnResources.create.step1.tip1':
    'The URL you want to speed up is usually the public display address open to users. After finishing, you can use our CNAME or your display address to speed up your resources.',
  'cdnResources.create.step1.tip2':
    'The URL you want to speed up is usually the public display address open to users. ',
  'cdnResources.create.step1.tip2.1':
    'Fill in the address of the web content source here, which can be URL or IP.',
  'cdnResources.create.step1.tip3':
    '(Note the URL format: {domain1}、 {domain2}，unavailable {domain3}）',
  'cdnResources.create.step1.tip3.0':
    'After finishing, you can use our CNAME or your display address to speed up your resources. Please note one CDNhostname per line.',
  'cdnResources.create.step1.tip3.1': 'Note the URL format: ',
  'cdnResources.create.step1.tip4':
    'When the origin policy is AUTO, filling in ports is not supported.',
  'cdnResources.create.step1.tip5': '(Wildcard domains must be created separately)',
  'cdnResources.create.step1.tip6': 'Wildcard domains must be created separately',
  'cdnResources.create.step1.NotSupported': '(Not currently supported)',
  'cdnResources.create.step1.help1': 'If you need more help, you can ',
  'cdnResources.create.step1.help2': 'click here.',
  'cdnResources.create.step1.origin.note1': 'Please note:',
  'cdnResources.create.step1.origin.note2': 'Multiple sources can only fill in IP format.',
  'cdnResources.create.step1.origin.message':
    'When more than one origin is used, only IP addresses are allowed.',
  'cdnResources.create.step1.origin.validatorMessage1': 'Please fill in a valid origin.',
  'cdnResources.create.step1.origin.validatorMessage2': 'Please fill in a valid CDN hostname.',
  'cdnResources.create.step1.origin.validatorMessage3': 'The IP already exists.',
  'cdnResources.create.step1.origin.validatorMessage4': 'Please fill in a valid IP addresses.',
  'cdnResources.create.step1.origin.validatorMessage5':
    'When using multiple sources, the port numbers must be consistent.',
  'cdnResources.create.step1.origin.validatorMessage6':
    'The current CDN hostname cannot be created.',
  'cdnResources.create.step1.origin.validatorMessage7': 'Please enter up to 10 IP addresses',
  'cdnResources.create.step1.origin.unique': 'The orign already exsists.',
  'cdnResources.create.step1.hostname.unique': 'The CDN hostname already exsists.',
  'cdnResources.create.step1.resourceName.unique': 'The Resource name already exsists.',
  //v1.2.0
  'cdnResources.create.StandardNetwork': 'Standard network',
  'cdnResources.create.CoreNetwork': 'Core network',
  'cdnResources.create.noPlan.modal.text': 'Insufficient Balance & No plan',
  'cdnResources.create.noPlan.modal.p': 'You still have free traffic to redeem!',
  'cdnResources.create.noPlan.modal.button': 'Get a offer',
  'cdnResources.create.No.additional': 'No additional charges required.',
  'cdnResources.detail.tabKey4.tier.Current': 'Current tier',
  'cdnResources.detail.tabKey4.tier.edit': 'Change tiers',
  'cdnResources.detail.tabKey4.tier.Usage': 'Usage of this month',
  'cdnResources.detail.tabKey4.tier.Unitprice': 'Unit price',
  'cdnResources.detail.tabKey4.EnableEdgeLocation': 'Enable edge location',
  'cdnResources.detail.tabKey4.tier.Modal.p1':
    'You currently do not have permission for this edge location. Please switch tier and try again.',
  'cdnResources.detail.tabKey4.tier.Recommended': 'Recommended tier: ',
  'cdnResources.create.NetworkList.moreFavorable': 'Get a more favorable price by click here',
  'cdnResources.create.title.resources': 'Create your CDN resources',
  'cdnResources.create.title.tier': 'Select your tier',
  'cdnResources.create.tier.loading':
    'We are processing resources for you, please wait a moment...',
  'cdnResources.create.NetworkList.tierRecharge.p1':
    'The following tier need to ensure sufficient balance, ',
  'cdnResources.create.NetworkList.tierRecharge.p2': 'go to recharge',
  'cdnResources.create.NetworkList.planLearn.p1':
    'You currently have a monthly plan, which will automatically activate the corresponding tier. ',
  'cdnResources.create.NetworkList.planLearn.p2': 'Learn about your monthly plan',
  'cdnResources.create.postpaid.price.p':
    'If the amount of traffic for half an hour is extremely small, we will deduct the minimum amount of $0.000001. If the amount exceeds this, we will deduct it according to normal billing.',
  'cdnResources.detail.NoPermission': 'No permission',
  'cdnResources.detail.SuggestedTier': 'Suggested tier: ',

  'cdnResources.detail.title': 'CDN Resources',
  'cdnResources.detail.tabKey1': 'Basic Settings',
  'cdnResources.detail.tabKey2': 'Advanced Settings',
  'cdnResources.detail.tabKey3': 'CDN Locations',
  'cdnResources.detail.tabKey4': 'Purge',
  'cdnResources.detail.tabKey5': 'Prefetch',
  'cdnResources.detail.tabKey6': 'Activate configuration',
  'cdnResources.detail.tabKey7': 'Safety protection',
  'cdnResources.detail.tabKey8': 'Rules',
  'cdnResources.detail.tabKey9': 'Optimizer',
  'cdnResources.detail.tabKey1.onSuccess.message': 'update successfully',
  'cdnResources.detail.tabKey1.title': 'Basic Information',
  'cdnResources.detail.tabKey1.cdnHostName.name': 'CDN hostname',
  'cdnResources.detail.tabKey1.cdnHostName.message': 'please enter',
  'cdnResources.detail.tabKey1.cdnHostName.placeholder':
    'Each CDN hostname needs to be filled in a new line, up to fifteen',
  'cdnResources.detail.tabKey1.cdnHostName.validatorMessage': 'Please enter a valid host name.',
  // 'cdnResources.detail.tabKey1.origin.name': 'Origin',
  'cdnResources.detail.tabKey1.port.name': 'Port',
  'cdnResources.detail.tabKey1.select.message': 'Please select',
  'cdnResources.detail.tabKey1.Button': 'Add',
  'cdnResources.detail.tabKey1.https.title': 'HTTPS configuration',
  'cdnResources.detail.tabKey1.https.alert':
    'Please note, the following domain names bound to the current resource have not been configured with certificates and will not be accessible through the HTTPS protocol: ',
  'cdnResources.detail.tabKey1.https.TLS.title': 'TLS Minimum Version',
  'cdnResources.detail.tabKey1.https.TLS.tip':
    'In terms of TLS selection, it is recommended to use TLS1.2 or 1.3. The current versions 1.0 and 1.1 have known vulnerabilities and should be avoided.',
  'cdnResources.detail.tabKey1.https.HTTP2.title': 'Enable HTTP/2',
  'cdnResources.detail.tabKey1.https.HTTP2.tip':
    'Enabling HTTP/2 can significantly improve performance and enhance user experience. Please ensure that the correct certificate is configured before it can take effect.',
  'cdnResources.detail.tabKey1.ssl.title': 'SSL',
  'cdnResources.detail.tabKey1.ssl.Tag1': 'Enabled',
  'cdnResources.detail.tabKey1.ssl.Tag2': 'Disabled',
  'cdnResources.detail.tabKey1.ssl.tip':
    'The accelerated domain name must have an SSL certificate before it can be accessed by HTTPS. You can open the SSL certificate to configure your domain name',
  'cdnResources.detail.tabKey1.ssl.tip1':
    'If you have multiple CDN hostnames, you can choose to upload multiple corresponding SSL certificates or wildcard certificates to ensure that all CDN hostnames can be accessed through HTTPS.',
  'cdnResources.detail.tabKey1.ssl.tip11': 'Please ensure that ',
  'cdnResources.detail.tabKey1.ssl.tip22': 'all ',
  'cdnResources.detail.tabKey1.ssl.tip33':
    'your CDN hostnames have been resolved to CNAME, otherwise the free certificate will fail to open.',
  'cdnResources.detail.tabKey1.ssl.group.label1': "Let's Encrypt",
  'cdnResources.detail.tabKey1.ssl.group.p1':
    "Please type the full hostname and ensure it doesn't end with '.cdn95.com' otherwise SSL cannot be enabled automatically.",
  'cdnResources.detail.tabKey1.ssl.group.label2': 'Custom SNI SSL',
  'cdnResources.detail.tabKey1.ssl.group.p2':
    'If you enable secondary CDN hostnames, the SNI certificate will be applied to both the CDN hostname and secondary CDN hostnames.',
  'cdnResources.detail.tabKey1.HostName.title': 'Secondary CDN Hostnames',
  'cdnResources.detail.tabKey1.HostName.modal.title': 'Save changes',
  'cdnResources.detail.tabKey1.HostName.modal.text1':
    "If you turn on the secondary CDN hostnames, we will automatically switch or turn on the Let's Encrypt SSL certificate for you.",
  'cdnResources.detail.tabKey1.HostName.modal.text2':
    'Are you sure you need to enable secondary CDN hostnames?',
  'cdnResources.detail.tabKey1.HostName.message1':
    'The CDN hostname that can be filled in has exceeded the upper limit!',
  'cdnResources.detail.tabKey1.HostName.message2':
    'It cannot be duplicated or the same as CDN hostname.',
  'cdnResources.detail.tabKey1.HostName.message3':
    'The domain name filled in cannot be the same as the CDN hostname.',
  'cdnResources.detail.tabKey1.HostName.message4':
    'It cannot be duplicated or the same as CDN hostname.', //and secondary CDN hostnames
  'cdnResources.detail.tabKey1.HostName.message5': 'It cannot be duplicated or the same as origin.',
  'cdnResources.detail.tabKey1.HostName.message6': 'It cannot be duplicated.',
  'cdnResources.detail.tabKey1.HostName.tip0.0':
    'If you are using the free certificate, after changing the CDN hostname and ensuring that the new domain name cname resolution is complete, you need to turn off and turn on the free certificate again to ensure that the certificate is synchronized to the new domain name.',
  'cdnResources.detail.tabKey1.HostName.tip0':
    'CDN hostnames supports adding multiple accelerated domain names. Please note one CDN hostname per line.',
  'cdnResources.detail.tabKey1.HostName.tip1':
    'Secondary CDN hostnames supports adding multiple accelerated domain names, allowing users to use parallel downloads to speed up page loading. You need to set a CNAME for the CDN hostname and the Secondary CDN hostnames. For more details,',
  'cdnResources.detail.tabKey1.HostName.tip2': ', please refer to the document.',
  'cdnResources.detail.tabKey1.origin.toRules': 'For more Origin settings, please go to ',
  'cdnResources.detail.tabKey2.tip.name':
    "How to bypass LightCDN's edge server and access the origin directly?",
  'cdnResources.detail.tabKey2.tip.pop': 'Click to enter the guide',
  'cdnResources.detail.tabKey2.tip.content':
    'You can try adding a cache rule for CDN resources with a Cache-Control header as "no-cache" or "max-age = 0" for specific files. At the same time, you can set Force Edge to never cache, forcing the CDN edge server to never cache requests in the cache rule.',
  'cdnResources.detail.tabKey2.HLS_force_cache.name': 'HLS force cache',
  'cdnResources.detail.tabKey2.HLS_force_cache.p1':
    'Force the m3u8 file edge server not to cache and support setting expiration times. This setting only takes effect when ',
  'cdnResources.detail.tabKey2.HLS_force_cache.p2': '"HLS optimization"',
  'cdnResources.detail.tabKey2.HLS_force_cache.p3': ' is enabled.',
  'cdnResources.detail.tabKey2.title': 'Cache expiration',
  'cdnResources.detail.tabKey2.Modal.title': 'Add SSL Certificates',
  'cdnResources.detail.tabKey2.cacheExpiry.name': 'Expiration period',
  'cdnResources.detail.tabKey2.cacheExpiry.message': 'please enter Expiration period!',
  'cdnResources.detail.tabKey2.cacheExpiry.fieldProps': 'min (default 12 days)',
  'cdnResources.detail.tabKey2.cacheExpiry.default': 'default',
  'cdnResources.detail.tabKey2.cacheExpiry404.name': 'Expiration period for 404 codes',
  'cdnResources.detail.tabKey2.cacheExpiry404.fieldProps': '1 minutes (default)',
  'cdnResources.detail.tabKey2.cacheExpiry.tip1':
    'The current experition period is for the entire site. When you have dynamic content, ',
  'cdnResources.detail.tabKey2.cacheExpiry.tip2': 'how can you ensure that it is not cached? →',
  'cdnResources.detail.tabKey2.rules.title': 'Configure',
  'cdnResources.detail.tabKey2.originPolicy.name': 'Origin policy',
  'cdnResources.detail.tabKey2.originPolicy.label1': 'AUTO',
  'cdnResources.detail.tabKey2.originPolicy.label2': 'HTTP',
  'cdnResources.detail.tabKey2.originPolicy.label3': 'HTTPS',
  'cdnResources.detail.tabKey2.originPolicy.tip1':
    "LightCDN's origin policy option allows you to set the protocol for pull requests from CDN edge servers to origin servers. You can check out the ",
  'cdnResources.detail.tabKey2.originPolicy.tip2': 'documentation',
  'cdnResources.detail.tabKey2.originPolicy.tip3': ' to learn more.',
  'cdnResources.detail.tabKey2.originPolicy.p1':
    'HTTP—connection between an edge server and an origin where HTTP is always used. It is a default value',
  'cdnResources.detail.tabKey2.originPolicy.p2':
    'HTTPS—connection between an edge server and an origin where HTTPS is always used',
  'cdnResources.detail.tabKey2.originPolicy.p3':
    "AUTO—connection between an edge server and an origin based on a visitor's request (HTTP or HTTPS). But please note that when your source has filled in the port, AUTO cannot be selected.",
  'cdnResources.detail.tabKey2.corsOn.name': 'CORS headers',
  'cdnResources.detail.tabKey2.corsOn.p1':
    'When enabled, enable cross domain resource sharing (CORS) by adding an HTTP header with access control allow origin',
  'cdnResources.detail.tabKey2.corsOn.p2': `If it is enabled and an error message is displayed when accessing the accelerated domain name, "No 'Access-Control-Allow-Origin' header is present on the requested resource.", please refer to the `,
  'cdnResources.detail.tabKey2.corsOn.p3': ' document ',
  'cdnResources.detail.tabKey2.corsOn.p4': 'for specific solutions.',
  'cdnResources.detail.tabKey2.RedirectHttp.name': 'Redirect Client from HTTP to HTTPS',
  'cdnResources.detail.tabKey2.RedirectHttp.p1':
    'After enabled, all HTTP requests will automatically redirect to the corresponding HTTPS URL, currently port number: ',
  'cdnResources.detail.tabKey2.hostHeaderForwarding.name': 'Host header forwarding',
  'cdnResources.detail.tabKey2.hostHeaderForwarding.p1': `CDN edge server will only go back to the origin when the file does not exist (cache) in
    the edge server (for ALL scenario), and the feature "passthrough http host header to
    origin" happens during the path from cdn edge --> origin. This feature is not
    about "making all requests goes back to origin", but "sending the host header info to origin".`,
  'cdnResources.detail.tabKey2.IgnoreSetCookie.name': 'Cache set-cookie',
  'cdnResources.detail.tabKey2.SkipSetCookie.name': 'Skip set-cookie',
  // 'cdnResources.detail.tabKey2.IgnoreSetCookie.p1':
  //   'CDNs set cookies for session tracking. Our CDN does not cache any content with Set-Cookie response headers, including static content like JPEG files. If you experience 0% cache hits due to this, enable this setting so that such responses are cached.',
  'cdnResources.detail.tabKey2.IgnoreSetCookie.p1':
    'LightCDN does not cache any content with a Set-Cookie response header, including static content such as JPEG. If this results in a 0% cache hit rate, please enable this setting to cache such responses. For more information on caching Set-Cookie, please refer to the ',
  'cdnResources.detail.tabKey2.IgnoreSetCookie.p2': 'document here.',
  'cdnResources.detail.tabKey2.HTTPSRedirect.name': 'HTTPS redirect',
  'cdnResources.detail.tabKey2.HTTPSRedirect.p1':
    'Returns a 301 Redirect response from http address to https address instead of loading from cache or upstream.',
  'cdnResources.detail.tabKey2.StreamingMedia.name': 'Streaming media',
  'cdnResources.detail.tabKey2.StreamingMedia.MP4': 'MP4 pseudo streaming',
  'cdnResources.detail.tabKey2.StreamingMedia.FLV': 'FLV pseudo streaming',
  'cdnResources.detail.tabKey2.StreamingMedia.HLS': 'HLS Optimization',
  'cdnResources.detail.tabKey2.StreamingMedia.HLS.p1':
    'If you want to create a rule to force cache expiration, you can quickly enable it in the cache rules section of the ',
  'cdnResources.detail.tabKey2.StreamingMedia.HLS.p2': ' page.',

  'cdnResources.detail.tabKey2.Websocket': 'Websocket',
  'cdnResources.detail.tabKey2.Websocket.Enable': 'Enable Websocket',
  'cdnResources.detail.tabKey2.Websocket.title1': 'Service scope',
  'cdnResources.detail.tabKey2.Websocket.title1.1':
    'Allow access to the source domain of websocket.',
  'cdnResources.detail.tabKey2.Websocket.title1.2':
    'Only allow access to Websocket services from source domains listed.',
  'cdnResources.detail.tabKey2.Websocket.title1.2.placeholder':
    '(Muti domain needs to be filled in line feed)',
  'cdnResources.detail.tabKey2.Websocket.title1.2.message': 'Please fill in a valid hostname',
  'cdnResources.detail.tabKey2.Websocket.title2': 'Source information',
  'cdnResources.detail.tabKey2.Websocket.title2.1.0': 'After selection, it means passing the value',
  'cdnResources.detail.tabKey2.Websocket.title2.1.1': ' "Origin" ',
  'cdnResources.detail.tabKey2.Websocket.title2.1.2': 'in the received request to the origin.',
  'cdnResources.detail.tabKey2.Websocket.title2.2':
    'Specify parameters to pass source information.',

  'cdnResources.detail.tabKey3.header1': 'Asia Pacific',
  'cdnResources.detail.tabKey3.header2': 'Middle East',
  'cdnResources.detail.tabKey3.header3': 'Europe',
  'cdnResources.detail.tabKey3.header4': 'North America',
  'cdnResources.detail.tabKey3.header5': 'South America',
  'cdnResources.detail.tabKey3.header6': 'Africa',
  'cdnResources.detail.tabKey3.text1': 'Silicon Valley',
  'cdnResources.detail.tabKey3.text2': 'Miami',
  'cdnResources.detail.tabKey3.text3': 'Washington',
  'cdnResources.detail.tabKey3.text4': 'Sao Paulo',
  'cdnResources.detail.tabKey3.text5': 'Frankfurt',
  'cdnResources.detail.tabKey3.text6': 'Dubai',
  'cdnResources.detail.tabKey3.text7': 'Singapore',
  'cdnResources.detail.tabKey3.text8': 'Ho Chi Minh',
  'cdnResources.detail.tabKey3.text9': 'Hong Kong',
  'cdnResources.detail.tabKey3.text10': 'Tokyo',
  'cdnResources.detail.tabKey3.text11': 'Riyadh',
  'cdnResources.detail.tabKey3.text12': 'Cairo',
  'cdnResources.detail.tabKey3.text13': 'London',
  'cdnResources.detail.tabKey3.text14': 'Marseille',
  'cdnResources.detail.tabKey3.text15': 'Bangkok',
  'cdnResources.detail.tabKey3.text16': 'Manila',
  'cdnResources.detail.tabKey3.text17': 'Hanoi',
  'cdnResources.detail.tabKey3.text18': 'Phnom Penh',
  'cdnResources.detail.tabKey3.text19': 'Muscat',
  'cdnResources.detail.tabKey3.text20': 'Johannesburg',
  'cdnResources.detail.tabKey3.text21': 'Bahrain',
  'cdnResources.detail.tabKey3.Panel1': 'Asia Pacific',
  'cdnResources.detail.tabKey3.Panel1.p1': 'Hongkong,China',
  'cdnResources.detail.tabKey3.Panel1.p2': 'Tokyo,Japan',
  'cdnResources.detail.tabKey3.Panel1.p3': 'Singapore',
  'cdnResources.detail.tabKey3.Panel1.p4': 'Bangkok,Tailand',
  'cdnResources.detail.tabKey3.Panel1.p5': 'Manila,Philippines',
  'cdnResources.detail.tabKey3.Panel1.p6': 'Hanoi,Vietnam',
  'cdnResources.detail.tabKey3.Panel1.p7': 'Phnom Penh,Cambodia',
  'cdnResources.detail.tabKey3.Panel2': 'Middle East',
  'cdnResources.detail.tabKey3.Panel2.p1': 'Dubai,The United Arab Emirates',
  'cdnResources.detail.tabKey3.Panel2.p2': 'Riyadh,Saudi Arabia',
  'cdnResources.detail.tabKey3.Panel2.p3': 'Muscat,Oman',
  'cdnResources.detail.tabKey3.Panel2.p4': 'Bahrain,The Kingdom of Bahrain',
  'cdnResources.detail.tabKey3.Panel3': 'Europe',
  'cdnResources.detail.tabKey3.Panel3.p1': 'Frankfurt,Germany',
  'cdnResources.detail.tabKey3.Panel3.p2': 'London,the United Kingdom',
  'cdnResources.detail.tabKey3.Panel3.p3': 'Marseille,France',
  'cdnResources.detail.tabKey3.Panel4': 'North America',
  'cdnResources.detail.tabKey3.Panel4.p1': 'San Mateo,America',
  'cdnResources.detail.tabKey3.Panel4.p2': 'Washington,America',
  'cdnResources.detail.tabKey3.Panel5': 'South America',
  'cdnResources.detail.tabKey3.Panel5.p1': 'Sao Paulo, Brazil',
  'cdnResources.detail.tabKey3.Panel6': 'Africa',
  'cdnResources.detail.tabKey3.Panel6.p1': 'Cairo,Egypt',
  'cdnResources.detail.tabKey3.Panel6.p2': 'Johannesburg,South Africa',
  'cdnResources.detail.tabKey4.tip':
    'The purge tool allows you to remove your cached content from all data centers instantly. You can purge files individually using a specific path or purge all files at once.',
  'cdnResources.detail.tabKey4.tip.0':
    ' You can also choose to use the API for operations. Please go to the',
  'cdnResources.detail.tabKey4.tip.1': ' account settings ',
  'cdnResources.detail.tabKey4.tip.2': 'to view the API address and API key.',
  'cdnResources.detail.tabKey4.Radio1': 'Purge all files',
  'cdnResources.detail.tabKey4.Radio2': 'Purge individual files',
  'cdnResources.detail.tabKey4.Radio3': 'Purge by paths',
  'cdnResources.detail.tabKey4.Radio3.0': 'URL directory',
  'cdnResources.detail.tabKey4.Prefetch.placeholder':
    'https://www.example.com/ (Multi path needs to be filled in line feed)',
  'cdnResources.detail.tabKey4.Radio2.purgeFiles.placeholder':
    'https://www.example.com/images/image01.png (Multi path needs to be filled in line feed)',
  'cdnResources.detail.tabKey4.Radio2.purgePaths.message': 'Please enter purge paths',
  'cdnResources.detail.tabKey4.Radio2.purgePaths.placeholder':
    'https://www.example.com/images/ (Multi path needs to be filled in line feed)',
  'cdnResources.detail.tabKey4.Radio2.purgePaths.Button': 'Purge Specified files',
  'cdnResources.detail.tabKey4.Radio2.errorMsg':
    'Invalid format.Suppot "https://www.example.com/images/image01.png".',
  'cdnResources.detail.tabKey4.Radio3.errorMsg':
    'Invalid format.Suppot "https://www.example.com/images/".',
  'cdnResources.detail.tabKey4.ProCard.title': 'Purge log',
  'cdnResources.detail.tabKey4.ProCard.inprocess': 'Purge...',
  'cdnResources.detail.tabKey4.ProCard.subTitle': '(Save log data for only 3 months)',
  'cdnResources.detail.tabKey4.ProCard.Option1': 'All',
  'cdnResources.detail.tabKey4.ProCard.Option2': 'Purge-all',
  'cdnResources.detail.tabKey4.ProCard.Option3': 'Purge-individual files',
  'cdnResources.detail.tabKey4.columns.purgePaths.Button': 'View file path',
  'cdnResources.detail.tabKey4.selected.message':
    'Please ensure that you have selected at least one acceleration edge location.',
  'cdnResources.detail.tabKey4.Modal.title': 'File paths',
  'cdnResources.detail.tabKey4.Modal.text': 'all files',

  'cdnResources.detail.tabKey4.ModalPurge.title': 'Purge all files',
  'cdnResources.detail.tabKey4.ModalPurge.text':
    'If you choose to clear all files, we will pull files from your source again. Are you sure you want to clear all caches?',
  'cdnResources.detail.tabKey4.ModalPurge.button': "Yes, I'm sure.",
  'cdnResources.detail.tabKey4.Modal.node.title': 'Acceleration nodes list',
  'cdnResources.detail.tabKey4.Modal.node.tip': 'After saving, the nodes you will accelerate are：',
  'cdnResources.detail.tabKey4.operateResult.COMPLETED': 'Completed',
  'cdnResources.detail.tabKey4.operateResult.IN_PROCESS': 'In process',
  'cdnResources.detail.tabKey4.operateResult.FAILED': 'Failed',

  'cdnResources.detail.tabKey5.onSuccess.message': 'submit successfully',
  'cdnResources.detail.tabKey5.tip': `The prefetch tool allows you to prepopulate newly added content into CDN caches. This is
    especially beneficial if you have recently uploaded a large file onto your server because
    you can quickly prompt the cache servers to get that file and force them to cache it.`,
  'cdnResources.detail.tabKey5.Form.prefetchPaths.message': 'Please enter prefetch paths',
  'cdnResources.detail.tabKey5.Form.prefetchPaths.Button': 'Prefetch Specified files',
  'cdnResources.detail.tabKey5.Prefetchlog.title': 'Prefetch log',
  'cdnResources.detail.tabKey5.Prefetchlog.inprocess': 'Prefetch...',
  'cdnResources.detail.tabKey5.validatorPaths.message00': 'Max 10 lines',
  'cdnResources.detail.tabKey5.validatorPaths.message01':
    'Domain name must not exceed 250 characters',
  'cdnResources.detail.tabKey5.validatorPaths.message0':
    'Invalid URL. Must start with http:// or https:// and use a configured CDN hostname.',
  'cdnResources.detail.tabKey5.validatorPaths.message1':
    'Invalid URL. Must be a complete path starting with http:// or https:// and use a configured CDN hostname.',
  'cdnResources.detail.tabKey5.validatorPaths.message2':
    'Invalid URL, currently no valid SSL certificate configured, only CDN hostnames with HTTP prefix can be preheated.',
  'cdnResources.detail.tabKey6.title1': 'Setup with CNAME',
  'cdnResources.detail.tabKey6.text1': 'Accelerate all static files through DNS.',
  'cdnResources.detail.tabKey6.text2': '1.You can add a CNAME to your hosting provider',
  'cdnResources.detail.tabKey6.text3': 'CDN hostname: ',
  'cdnResources.detail.tabKey6.text4': 'CNAME: ',
  'cdnResources.detail.tabKey6.text4.tip':
    'Please note that the cname domain name will no longer grant direct access. This will ensure the security of all users.',
  'cdnResources.detail.tabKey6.text5':
    '2.DNS generation takes some time. You can use the following tools to check the DNS ',
  'cdnResources.detail.tabKey6.text6': 'status: ',
  'cdnResources.detail.tabKey6.text7': "3.It's DONE!",
  'cdnResources.detail.tabKey6.text8':
    'Start your LightCDN CDN journey! If you have any other questions, you can contact our',
  'cdnResources.detail.tabKey6.text9': 'customer service',
  'cdnResources.detail.tabKey6.title2': 'Setup without CNAME',
  'cdnResources.detail.tabKey6.title11':
    'Simple setup, just update the URLs pointing to your static files.',
  'cdnResources.detail.tabKey6.title12':
    '1.Change the Origin path for each file you want to deliver through the CDN (images, videos, CSS, etc.): ',
  'cdnResources.detail.tabKey6.title13': 'Without CDN: ',
  'cdnResources.detail.tabKey6.title14': 'With CDN: ',
  'cdnResources.detail.tabKey6.text15': "2.It's DONE!",
  //v1.3.3
  'cdnResources.detail.tabKey6.ActivateDiagnosis.imgText':
    'Click diagnose and check your CDN hostname status',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.url.placeholder': 'Enter an accessible path',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.btnText': 'Diagnose',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.reBtnText': 'Rediagnose',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.status.success': 'Normal',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.status.error': 'Error warning',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.status.warn': 'Abnormal',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.btnTimeText': 'Last diagnosis time: ',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.1': 'Normal',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.2': 'Unresolved',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.3': 'Abnormal',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.3.tip':
    'Failed to resolve to the correct address',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.name': 'DNS resolution',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.text.1': 'Configured',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.text.2': 'Not configured',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.textTo': 'Go to configure',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.name': 'SSL certificate',
  // 'cdnResources.detail.tabKey6.ActivateDiagnosis.step3.text': '500',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step3.name': 'Page status',
  // 'cdnResources.detail.tabKey6.ActivateDiagnosis.step4.text': "",
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step4.name': 'Acceleration status',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.testPlace': 'Test place',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.testDomain': 'Test domain',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.invalidURL':
    'Invalid URL, the path does not exist',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.moreTip':
    "Isn't this the problem? View more common problems and corresponding solutions →",
  'cdnResources.detail.tabKey6.ActivateDiagnosis.TLS13':
    'TLS1.3 does not currently support diagnosis',

  'cdnResources.detail.tabKey7.title': 'Access protection',
  'cdnResources.detail.tabKey7.accessCountry.name': 'Country access', //countries
  'cdnResources.detail.tabKey7.CountryAccess.p1':
    "Configure a rule to enable/disable access to the CDN resource's content for specified countries.",
  'cdnResources.detail.tabKey7.CountryAccess.p2': 'You {val}, except some countries. ',
  'cdnResources.detail.tabKey7.clickHere': 'Click here for the list.',
  'cdnResources.detail.tabKey7.countries.title': '(Except for countries)', //，can be blank
  'cdnResources.detail.tabKey7.accessHotlink.name': 'Hotlink policy', //hotlinkDomains
  'cdnResources.detail.tabKey7.hotlinkPolicy.p1':
    'Configure a rule to enable/disable access to the CDN resource’s content for specified URL.',
  'cdnResources.detail.tabKey7.hotlinkPolicy.p2': 'You {val}, except some dmians. ',
  'cdnResources.detail.tabKey7.hotlinkPolicy.p3': '(The CDN hostname will be added by default.)',
  'cdnResources.detail.tabKey7.domians.title': '(Except for domians)', //，can be blank
  'cdnResources.detail.tabKey1.domians.message': 'Please input domians!',
  'cdnResources.detail.tabKey1.domians.placeholder':
    'www.example.com/*.example.com(Multi domain needs to be fillede in line feed.)',
  'cdnResources.detail.tabKey7.accessIp.name': 'IP access', //ipAddresses
  'cdnResources.detail.tabKey7.IPAccess.p1':
    'Configure a rule to enable/disable access to the CDN resource’s content for a range of IP addresses, including both IPv4 and IPv6.',
  'cdnResources.detail.tabKey7.IPAccess.p2': 'You {val}, except some IP addresses. ',
  'cdnResources.detail.tabKey7.addresses.title': '(Except for IP addresses)', //，can be blank
  'cdnResources.detail.tabKey1.addresses.message': 'Please input IP addresses!',
  'cdnResources.detail.tabKey1.addresses.placeholder':
    '10.10.10.10\n20.20.20.0/24\n2001:CDBA::64\n...',
  'cdnResources.detail.tabKey7.urlSigningVO.name': 'URL signing', //URLSigning
  'cdnResources.detail.tabKey7.URLSigning.p1':
    'Protect your files from unauthorized access with a key.  ',
  'cdnResources.detail.tabKey7.signingKey.title': 'URL signing key',
  'cdnResources.detail.tabKey7.URLSigning.Generate': 'Generate a new one',
  'cdnResources.detail.tabKey7.URLSigning.message':
    'Please enter a string of 6-32, spaces are not supported',
  'cdnResources.detail.tabKey7.URLSigning.validatorMessage': 'Url signing key is invalid.',
  'cdnResources.detail.tabKey7.URLSigning.form.Param': 'Param',
  'cdnResources.detail.tabKey7.URLSigning.form.Value': 'Value',
  'cdnResources.detail.tabKey7.URLSigning.form.Key': 'Key',
  'cdnResources.detail.tabKey7.URLSigning.form.Param.pop':
    'The default value is "sign". If your encrypted string is a different parameter, please fill it in.',
  'cdnResources.detail.tabKey7.URLSigning.form.TTL.pop':
    'The effective time of the link. Due to the dynamic generation of URLs in URL authentication, the cache time setting for the page where the link is located cannot exceed the effective time of the authentication setting.',
  'cdnResources.detail.tabKey7.crawlers.name': 'Block search engine crawlers',
  'cdnResources.detail.tabKey7.crawlers.p1':
    'Block search engine crawlers is used to block web crawling bots from indexing the CDN content.',
  'cdnResources.detail.tabKey7.Modal.here.title': 'List for {name}',
  'cdnResources.detail.tabKey7.Modal.here.tip': 'You {val}, except for:',
  'cdnResources.detail.tabKey7.SafetyWaf.name': 'OWASP TOP THREATS',
  'cdnResources.detail.tabKey7.SafetyWaf.title': 'WAF',
  'cdnResources.detail.tabKey7.SafetyWaf.tip1':
    'If you do not know the specific definition of WSAP, you can check the ',
  'cdnResources.detail.tabKey7.SafetyWaf.tip2': 'document',
  'cdnResources.detail.tabKey7.SafetyWaf.tip3': ' to understand.',
  'cdnResources.detail.tabKey7.URLSigning.pop1':
    'A secure token consists of the following parameters:',
  'cdnResources.detail.tabKey7.URLSigning.pop2':
    'Expires—the expiration time of a URL or the time when an URL becomes invalid. The time is passed in the URL itself in a Unix timestamp format and takes part in hash generation. It is an optional parameter.',
  'cdnResources.detail.tabKey7.URLSigning.pop3': 'Path—a file path or file directory',
  'cdnResources.detail.tabKey7.URLSigning.pop4': 'Key—a URL signing key',
  'cdnResources.detail.tabKey7.URLSigning.pop5':
    'IP— an IP that provides access. It is optional and only one IP allowed when generating the hash key each time.',
  'cdnResources.detail.tabKey7.URLSigning.pop6':
    'A signed URL can be in one of the following formats:',
  'cdnResources.detail.tabKey7.URLSigning.pop7':
    'Query string format: http://example.com/filename?secure=DMF1ucDxtqgxwYQ&expires=1546300800&ip=1.2.3.4',
  'cdnResources.detail.tabKey7.URLSigning.pop8':
    'Path format: http://example.com/secure=DMF1ucDxtqgxwYQ&expires=1546300800&ip=1.2.3.4/filename',
  'cdnResources.detail.tabKey7.Access.label1': ' Disabled',
  'cdnResources.detail.tabKey7.Access.label2': ' Allow all by default',
  'cdnResources.detail.tabKey7.Access.label3': ' Block all by default',
  'cdnResources.detail.tabKey7.allowed': 'allowed all by default',
  'cdnResources.detail.tabKey7.block': 'blocked all by default',
  'cdnResources.detail.tabKey7.disabled': 'disabled',

  'cdnResources.detail.tabKey7.SafetyNginx.title': 'Nginx Settings',
  'cdnResources.detail.tabKey7.SafetyNginx.title1': 'Rate Settings',
  'cdnResources.detail.tabKey7.SafetyNginx.title2': 'Cache Key',
  'cdnResources.detail.tabKey7.SafetyNginx.text1':
    'Support limiting the corresponding speed of each request to customers.',
  'cdnResources.detail.tabKey7.SafetyNginx.text2': 'Current setting:  When the request reaches',
  'cdnResources.detail.tabKey7.SafetyNginx.text3': ', the response speed drops to',
  'cdnResources.detail.tabKey7.SafetyNginx.text4':
    'Support selecting one of the four types of keys to cache.',
  'cdnResources.detail.tabKey7.SafetyNginx.message': 'Please do not exceed 2T.',
  // v1.1.13
  'cdnResources.detail.tabKey8.tabs1': 'Cache rules',
  'cdnResources.detail.tabKey8.tabs2': 'Redirect rules',
  'cdnResources.detail.tabKey8.tabs3': 'Modify header',
  'cdnResources.detail.tabKey8.tabs3.1': 'Request headers',
  'cdnResources.detail.tabKey8.tabs3.2': 'Response headers',
  'cdnResources.detail.tabKey8.tabs3.3': 'Get client IP in request header',
  'cdnResources.detail.tabKey8.tabs3.header': 'Header',
  'cdnResources.detail.tabKey8.tabs3.Edit.succeeded': 'Edit succeeded',
  'cdnResources.detail.tabKey8.tabs4': 'Origin rules',
  'cdnResources.detail.tabKey8.tabs.tip0':
    'How to bypass the edge server of LightCDN and directly access the origin? ',
  'cdnResources.detail.tabKey8.tabs.tip1':
    'Is there too many redirection prompts when accessing the origin through CDN? ',
  'cdnResources.detail.tabKey8.tabs.tip2': 'Let’s see how to solve it! →',
  'cdnResources.detail.tabKey8.tabs.tip3': "Let's take a look at how to solve it! →",
  'cdnResources.detail.tabKey8.tabs1.create': 'Create a new rule', // {num}
  'cdnResources.detail.tabKey8.tabs1.p1': 'Customize HTTP caching rules. ',
  'cdnResources.detail.tabKey8.tabs1.p2': 'Read the documentation to learn more.',
  'cdnResources.detail.tabKey8.tabs1.p3.1': 'You can currently create ',
  'cdnResources.detail.tabKey8.tabs1.p3.2': 'rules. ',
  'cdnResources.detail.tabKey8.tabs1.p3.3': 'Go buy more rules.',
  'cdnResources.detail.tabKey8.tabs1.p4': 'Go buy more rules.',
  'cdnResources.detail.tabKey8.tabs1.table.title1': 'Name',
  'cdnResources.detail.tabKey8.tabs1.table.title2': 'Options',
  'cdnResources.detail.tabKey8.tabs1.table.compensation': 'System compensation',
  'cdnResources.detail.tabKey8.tabs1.form.title1.message': 'Please input Name!',
  'cdnResources.detail.tabKey8.tabs1.form.title1.exists': 'The rule name already exists.',
  'cdnResources.detail.tabKey8.tabs1.form.title1.invalidName':
    'Invalid name, please enter letters or numbers.',
  'cdnResources.detail.tabKey8.tabs1.form.invalidName': 'Invalid name',
  'cdnResources.detail.tabKey8.tabs1.form.title1.cnMessage': 'Please enter letters or numbers.',
  'cdnResources.detail.tabKey8.tabs1.form.title1.button': 'Generate a name',
  'cdnResources.detail.tabKey8.tabs1.form.title2': 'Conditions(When incoming requests match...)',
  'cdnResources.detail.tabKey8.tabs1.form.title3': 'Actions ( Then...)',
  'cdnResources.detail.tabKey8.tabs1.form.title4': 'Act',
  'cdnResources.detail.tabKey8.tabs1.form.title4.message': 'Please input Act',
  'cdnResources.detail.tabKey8.tabs1.form.title4.message1':
    'Please select at least one action to enable.',
  'cdnResources.detail.tabKey8.tabs1.form.title5': 'Never cache',
  'cdnResources.detail.tabKey8.tabs1.form.title6': 'Cache',
  'cdnResources.detail.tabKey8.tabs1.form.title7': 'Force edge to never cache',
  'cdnResources.detail.tabKey8.tabs1.form.title8': 'Force client to never cache',
  'cdnResources.detail.tabKey8.tabs1.form.title9': 'Force edge to cache',
  'cdnResources.detail.tabKey8.tabs1.form.title10': 'Force client to cache',
  'cdnResources.detail.tabKey8.tabs1.form.title11': 'Override default cache validity',
  'cdnResources.detail.tabKey8.tabs1.form.title12': 'TTL',
  'cdnResources.detail.tabKey8.tabs1.form.title12.message': 'Please enter TTL',
  'cdnResources.detail.tabKey8.tabs1.form.title7.text':
    'Forces the CDN edge server to never cache the request. However, if the request is already cached (for example, if it was cached prior to setting up this rule), it will not be forced out of cache.',
  'cdnResources.detail.tabKey8.tabs1.form.title8.text':
    'Forces the client to never cache the request. This is achieved by removing all Cache-Control and Expires response headers, sending instead “Cache-Control: no-cache”.',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text':
    'Forces the CDN edge server to cache the request for a specified duration. ',
  'cdnResources.detail.tabKey8.tabs1.form.title9.second':
    'This overrides any Cache-Control or Expires headers from the origin, even if they specify “private” or “no-cache”. The value must be 1 minute or longer.',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text.0':
    'Forces the CDN edge server to cache the request for a specified duration. This feature is suitable for business scenarios where',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text.1': ' content updates are not frequent.',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text.2': ' ',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.0':
    'Forces the client to cache the request for a specified duration. This feature is suitable for business scenarios where content needs to be',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.1': ' updated frequently.',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.2': '',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.3':
    'This overrides any Cache-Control or Expires headers from the origin, even if they specify “private” or “no-cache”. The value must be 1 minute or longer.',
  'cdnResources.detail.tabKey8.tabs1.form.title11.text':
    'Changes the CDN edge server’s default validity period for origin responses that do not explicitly specify Cache-Control or Expires. Responses with Cache-Control or Expires headers are still honored.',
  'cdnResources.detail.tabKey8.tabs1.form.item1.name': 'Connective',
  'cdnResources.detail.tabKey8.tabs1.form.item2.name': 'Subject',
  'cdnResources.detail.tabKey8.tabs1.form.item3.name': 'Cookie/Param/Header',
  'cdnResources.detail.tabKey8.tabs1.form.item3.message': 'Please input Cookie/Param/Header',
  'cdnResources.detail.tabKey8.tabs1.form.item4.name': 'Predicate',
  'cdnResources.detail.tabKey8.tabs1.form.item5.name': 'Value',
  'cdnResources.detail.tabKey8.tabs1.form.item5.message': 'Please input Value',
  'cdnResources.detail.tabKey8.tabs1.form.create': 'Create a new rule',
  'cdnResources.detail.tabKey8.tabs1.form.save': 'Save changes',
  'cdnResources.detail.tabKey8.tabs1.form.extensionEqual.tip':
    'Tips: The subject of extensions allows you to fill in multiple extension names in one condition. Please use the English characters [,] to separate the extension names.',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip':
    'Tips: The IP subject allows you to fill in multiple IPs in one condition. When you choose in range, two are three formats to choose from.',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip.0':
    '(1) Start IP, end IP, separated by a dash[-] in English. example: 192.168.1.100-192.168.2.200',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip.1': '(2) CIDR format. Example: 192.168.2.1/24',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip.2':
    '(3) Multiple single IP addresses, separated by commas[,] in English. Example: 1.1.1.1,2.2.2.2',
  //v1.3.3
  'cdnResources.detail.tabKey8.tabs1.form.url.tip':
    'Tips: The format of the URL subject should follow the complete request URL, including protocol, domain name, request path, parameters, etc., similar to http://cdn.example.com/image.jpg?name=cdn .',

  'cdnResources.detail.tabKey8.tabs1.PopoverText1': 'Edit',
  'cdnResources.detail.tabKey8.tabs1.PopoverText2': 'Delete',
  'cdnResources.detail.tabKey8.tabs1.Delete.content':
    'The rule will become invalid after deletion. Are you sure you want to delete it?',
  'cdnResources.detail.tabKey8.tabs2.title': 'Quickly enable configuration',
  'cdnResources.detail.tabKey8.tabs2.QuicklyEnable': 'Quickly enable',
  'cdnResources.detail.tabKey8.tabs2.card.title': 'HTTPS redirect',
  'cdnResources.detail.tabKey8.tabs2.card.p1':
    'Returns a 301 Redirect response from http address to https address instead of loading from cache or upstream.',
  'cdnResources.detail.tabKey8.tabs2.card.p2':
    'We will directly generate a rule for you and display it in the list below.',
  'cdnResources.detail.tabKey8.tabs2.p1':
    'Create rules to redirect visitors from a source URL to a target URL. ',
  'cdnResources.detail.tabKey8.tabs2.code.name1': 'Redirection function',
  'cdnResources.detail.tabKey8.tabs2.code.name2': 'Rule list',
  'cdnResources.detail.tabKey8.tabs2.code.title': 'Site redirection',
  'cdnResources.detail.tabKey8.tabs2.code.p':
    'Please note that after enabling site redirection, this rule will take precedence over other rules, and all requests accessing the CDN hostname will be automatically redirected to the domain name you have set. If the URL filled in does not contain a prefix, http/https, Maintain the protocol by default.',
  'cdnResources.detail.tabKey8.tabs2.code.col.1': 'URL after redirection',
  'cdnResources.detail.tabKey8.tabs2.code.col.message': 'Please enter the URL after the redirect',
  'cdnResources.detail.tabKey8.tabs2.code.col.2': 'Status code',
  'cdnResources.detail.tabKey8.tabs2.code.col.302': '302 - Temporary redirect',
  'cdnResources.detail.tabKey8.tabs2.code.col.301': '301 - Permanent Redirect',
  'cdnResources.detail.tabKey8.tabs2.form.title1': 'Forbid client',
  'cdnResources.detail.tabKey8.tabs2.form.title2': 'Set Redirection',
  'cdnResources.detail.tabKey8.tabs2.form.title3': 'Redirect Client from HTTP to HTTPs',
  'cdnResources.detail.tabKey8.tabs2.form.title4': 'Redirect Client',
  'cdnResources.detail.tabKey8.tabs2.form.title5': 'URL',
  'cdnResources.detail.tabKey8.tabs2.form.title5.message': 'Please input URL',
  'cdnResources.detail.tabKey8.tabs2.form.title1.text':
    'Returns a simple 403 Forbidden response to the client.',
  'cdnResources.detail.tabKey8.tabs2.form.title2.text':
    'Returns a 301 Redirect response from http address to https address instead ofloading from cache or upstream.',
  'cdnResources.detail.tabKey8.tabs2.form.title2.text.1':
    'When there are multiple CDN hostnames, it is necessary to choose one.',
  'cdnResources.detail.tabKey8.tabs2.form.title3.text':
    'Return the 302 redirect response to the specified URL on the client. This will apply to all CDN hostnames. If the URL filled in does not include a prefix, ',
  'cdnResources.detail.tabKey8.tabs2.form.title3.text1':
    ', the protocol will be maintained by default.',
  'cdnResources.detail.tabKey8.tabs2.form.title3.select.text': 'Redirect object',
  'cdnResources.detail.tabKey8.tabs3.p1': 'Adjust HTTP headers of requests at the edge. ',
  'cdnResources.detail.tabKey8.tabs3.p2': 'Adjust HTTP headers of responses at the edge. ',
  'cdnResources.detail.tabKey8.tabs3.p2.0':
    'Get client IP from request header. A header name must be provided. Common headers include',
  'cdnResources.detail.tabKey8.tabs3.p2.1': ' X-Forwarded-For, X-Real IP, X-Client IP ',
  'cdnResources.detail.tabKey8.tabs3.p2.2': ', etc.',
  'cdnResources.detail.tabKey8.tabs3.form.title1': 'Set request header',
  'cdnResources.detail.tabKey8.tabs3.form.title2': 'Set response header',
  'cdnResources.detail.tabKey8.tabs3.form.title3': 'Set client IP in request header',
  'cdnResources.detail.tabKey8.tabs3.form.title1.create': 'Create request header',
  'cdnResources.detail.tabKey8.tabs3.form.title2.create': 'Create response header',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Header': 'Header',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Header.message': 'Please input Header',
  'cdnResources.detail.tabKey8.tabs3.form.title1.HeaderValue.message':
    'Please input Header and Value',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Value': 'Value',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Value.message': 'Please input Value',
  'cdnResources.detail.tabKey8.tabs3.form.title1.text':
    'Overrides a request header to the origin. A header name and header value must be provided.',
  'cdnResources.detail.tabKey8.tabs3.form.title2.text':
    'Overrides a response header to the client. A header name and header value must be provided.',
  'cdnResources.detail.tabKey8.tabs3.form.title3.text':
    'Sets the client’s IP address in a request header to the origin. A header name must be provided.',
  'cdnResources.detail.tabKey8.tabs3.form.title4.text':
    'Overrides a response header to the origin. A header name and header value must be provided.',
  'cdnResources.detail.tabKey8.tabs4.p1':
    'Customize the destination of the origin request for configuration. ',
  'cdnResources.detail.tabKey8.tabs4.form.title1': 'Prepend Origin Directory',
  'cdnResources.detail.tabKey8.tabs4.form.title2': 'Set Custom Origin',
  'cdnResources.detail.tabKey8.tabs4.form.title3': 'Passthrough HTTP Host Header to Origin',
  'cdnResources.detail.tabKey8.tabs4.form.title4': 'Other settings',
  'cdnResources.detail.tabKey8.tabs4.form.title1.text':
    'Prepends a directory to the URL when the edge server requests it from the origin.',
  'cdnResources.detail.tabKey8.tabs4.form.title2.text':
    'Overrides the origin that the edge server connects to.',
  'cdnResources.detail.tabKey8.tabs4.form.title3.text':
    'Goes back to the origin when the condition = true, during the first time, and the subsequent request (being cached in edge) will not go back to the origin again although the condition = true.',
  'cdnResources.detail.tabKey8.InvalidFormat': 'Invalid format',
  'cdnResources.detail.tabKey8.tabs4.title.1': 'Origin server hostname',
  'cdnResources.detail.tabKey8.tabs4.title.1.0':
    'The choice of origin server hostname affects the domain name received when requesting the origin. The default is CDN acceleration domain name.Still not familiar with the origin server hostname, ',
  'cdnResources.detail.tabKey8.tabs4.title.1.0.0': 'click to view more detailed content →',
  'cdnResources.detail.tabKey8.tabs4.title.1.1.0':
    'Follow CDN Hostname: "Follow CDN Hostname" refers to keeping the domain name received by the source site consistent with the current CDN hostname. This type is mainly used when',
  'cdnResources.detail.tabKey8.tabs4.title.1.1.1':
    '  the source site supports multi domain hosting',
  'cdnResources.detail.tabKey8.tabs4.title.1.1.2':
    ', accurately matching requests and avoiding 404/400 errors.',
  'cdnResources.detail.tabKey8.tabs4.title.1.2.0':
    'Follow Origin: "Follow Origin" refers to the domain name received by the source site still being the information filled in the source site address, and not changing with the proxy service domain name. It is mostly used for',
  'cdnResources.detail.tabKey8.tabs4.title.1.2.1':
    ' source sites that only serve a single domain name',
  'cdnResources.detail.tabKey8.tabs4.title.1.2.2':
    ', with good compatibility and no need to modify the origin configuration.',
  'cdnResources.detail.tabKey8.tabs4.title.1.3':
    'Customization: Custom Host content supports request variables.',
  'cdnResources.detail.tabKey8.tabs4.title.1.type1': 'Follow CDN Hostname',
  'cdnResources.detail.tabKey8.tabs4.title.1.type2': 'Follow Origin',
  'cdnResources.detail.tabKey8.tabs4.title.1.type3': 'Customization',
  'cdnResources.detail.tabKey8.tabs4.title.2': 'Prepend origin directory',
  'cdnResources.detail.tabKey8.tabs4.title.2.0':
    'When the edge server requests from the origin, set the directory to a pre prepared URL. For example, if the value is ',
  'cdnResources.detail.tabKey8.tabs4.title.2.00': '“images”',
  'cdnResources.detail.tabKey8.tabs4.title.2.1': ', the client requests from the edge server: ',
  'cdnResources.detail.tabKey8.tabs4.title.2.10': '“http://cdn.example.com/photo.jpg”',
  'cdnResources.detail.tabKey8.tabs4.title.2.2': ', the edge server requests from the origin: ',
  'cdnResources.detail.tabKey8.tabs4.title.2.20': '“http://cdn.example.com/images/photo.jpg”',
  'cdnResources.detail.tabKey8.tabs4.title.3': 'Automatically add headers',
  'cdnResources.detail.tabKey8.tabs4.title.3.0':
    'After selection, it will automatically request the origin to add these headers, so that the origin can obtain client information.',

  'cdnResources.detail.tabKey8.tabs4.RequestLimiting': 'Request limiting',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.1': 'Maximum concurrency',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.1.0':
    'The maximum concurrency for the current website, exceeding this limit will result in a 429 code response from the user.',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.1.1':
    ' A value of 0 indicates no restriction.',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.2': 'Maximum concurrency per IP',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.2.0':
    'The maximum concurrency per IP, when calculating the total number of connections per IP, does not differentiate between websites. If this limit is exceeded, a response will be given to the user 429 code.',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.2.1':
    ' A value of 0 indicates no restriction.',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.3': 'Bandwidth limit per request',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.3.0':
    'The downstream traffic that a single client request can use per second.',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.3.1': ' This can be blank.',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.4': 'Maximum size per request',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.4.0':
    'The maximum content size that a single request can send.',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.4.1': ' This can be blank.',
  'cdnResources.detail.tabKey8.tabs4.EnabledMode': ' Enabled mode',
  'cdnResources.detail.tabKey8.tabs4.CurrentSetting': 'Current setting: ',
  'cdnResources.detail.tabKey8.tabs4.Unlimited': 'Unlimited',
  //v1.3.6
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title': 'CC protection',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title1': 'Protection settings',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title2': 'Access statistics',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title3': 'Blocked IP',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title4': 'CC Allowlist',
  'cdnResources.detail.tabKey8.tabs6.5SShield.title': '5-Second shield',
  'cdnResources.detail.tabKey8.tabs5.CCSet.title': 'Protection Settings',
  'cdnResources.detail.tabKey8.tabs5.CCSet.text': 'Enable CC protection',
  'cdnResources.detail.tabKey8.tabs5.CCSet.tip1': 'Not sure what CC protection is? ',
  'cdnResources.detail.tabKey8.tabs5.CCSet.tip2': 'How to use it? Check it out →',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1': 'Blocking threshold',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text1':
    'Automatic - Dynamically sets thresholds based on website traffic automatically. Recommended for most scenarios.',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text2':
    'Default - Uses preset security values, suitable for businesses with relatively stable traffic. Current system default threshold settings: Single IP, max 60 requests per 5 seconds; max 150 requests per 60 seconds; max 300 requests per 300 seconds.',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text3':
    'Custom - Manual settings, requires familiarity with business traffic.',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content1': 'Single IP, max per 5 seconds',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content2': 'Single IP, max per 60 seconds',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content3': 'Single IP, max per 300 seconds',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content4': 'requests',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav2': 'Blocking intensity',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav2.text':
    'Higher levels result in longer IP ban durations.',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav3': 'Ignore common files',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav3.text':
    'Ignore file names commonly referenced on webpages, such as js, css, jpg, etc. Access to these files is not counted, reducing false positives. However, directly accessing these files (e.g., opening them directly in a browser) will still be counted.',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav4': 'Check request origin fingerprint',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav4.text':
    'Attempts to check the fingerprint of the request origin when receiving HTTPS requests to detect proxy services and crawler attacks; if you have another reverse proxy service in front of your website, please disable this option.',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav5': 'GET302 verification',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav5.text':
    'When enabled, indicates automatic verification of the client via the GET302 method.',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6': 'Detection threshold',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6.text':
    'Detection starts only when the average QPS of a single IP reaches this value within 1 minute; 0 means detection for any access.',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6.text.content1': 'Min QPS per IP',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6.text.content2': 'requests/s',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav7': 'Protection scope',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav7.text1':
    'The list is used to differentiate content for special configurations. Currently selecting the "Protection List" means CC protection will only be applied to these URLs.',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav7.text2':
    'The list is used to differentiate content for special configurations. Currently selecting the "Exclusion List" means these URLs will skip CC protection without any processing.',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav8': 'Email alerts',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav8.text':
    'When enabled, sends email alerts when potential risks are detected or CC protection triggers automatic blocking.',
  'cdnResources.detail.tabKey8.tabs5.CCSet.suggestion': 'Recommended to enable',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.tip1':
    'The real-time IP visit count is an estimate based on the last five minutes. You can view blacklisted IPs in the ',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.tip2': 'Blocked IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.tip3': ' section →',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column1': 'IP information',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column2': 'Average access volume',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column3': 'Total access volume',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column4': 'Action',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIP': 'Blacklist IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.whiteIP': 'Add to whitelist',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item0': 'IP or IP range',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item1': 'IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item2': 'Auto release time',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item3': 'Remarks',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item4': 'Quick select: ',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item5': '1 Hour',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item6': '1 Day',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item7': '3 Days',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item8': '1 Week',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item9': '30 Days',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item10': '1 Year',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.defaultReason':
    'Suspected CC attack',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.btn': 'Add blacklist IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.Modal.placeholder':
    '10.10.10.10\n20.20.20.0/24\n2001:CDBA::64\nMultiple entries separated by line breaks, supports IPv4 or IPv6',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.column1': 'Block end time',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.column2': 'Block reason',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.column3': 'Request path',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.remove': 'Release',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.intercepted': 'Intercepted',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.title': 'Release block',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text1': 'This IP',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text2': 'is scheduled to be released at',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text3': '.',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text4':
    'Are you sure you want to release the block now?',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.tip':
    'IPs added to the CC Allowlist will skip CC protection detection.',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.addButton': 'Add CC Allowlist',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.column1': 'Type',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.column2': 'Creation time',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.delete': 'Delete',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.addButton.btnText': 'Add whitelist IP',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.deleteModal.text':
    'Are you sure you want to remove the IP from the whitelist',
  'cdnResources.detail.tabKey8.tabs5.SShield.text': 'Enable 5-Second shield',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav1': 'Verification validity period',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav1.text':
    'Once a single client passes verification, no re-verification occurs within this validity period; 0 indicates the system default.',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav1.second': 'second',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav2': 'Min QPS per IP',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav2.text':
    'Triggers the 5-second shield only when the average QPS of a single IP reaches this value within 1 minute; if set to 0, it triggers for any access.',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav3': 'Add to IP whitelist',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav3.text':
    'When enabled, IPs that pass verification are added to a temporary whitelist; this IP will not be checked by the 5-second shield on the next visit. This whitelist only applies to the 5-second shield and does not affect other rules. This option is mainly used for websites that may not function properly with cookies.',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav4': 'Protection scope',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav4.text1':
    'The list is used to differentiate content for special configurations. Currently selecting the "Protection List" means 5-second Shield protection will only be applied to these URLs.',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav4.text2':
    'The list is used to differentiate content for special configurations. Currently selecting the "Exclusion List" means these URLs will skip the 5-second Shield without any processing.',
  'cdnResources.detail.tabKey8.tabs5.enum.threshold.0': 'Automatic',
  'cdnResources.detail.tabKey8.tabs5.enum.threshold.1': 'Default',
  'cdnResources.detail.tabKey8.tabs5.enum.threshold.2': 'Custom',
  'cdnResources.detail.tabKey8.tabs5.enum.strength.0': 'Low',
  'cdnResources.detail.tabKey8.tabs5.enum.strength.1': 'Medium',
  'cdnResources.detail.tabKey8.tabs5.enum.strength.2': 'High',
  'cdnResources.detail.tabKey8.tabs5.enum.range.0': 'Disabled',
  'cdnResources.detail.tabKey8.tabs5.enum.range.1': 'Protection list',
  'cdnResources.detail.tabKey8.tabs5.enum.range.2': 'Exclusion list',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0': 'Wildcard',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.placeholder':
    'Use asterisk (*) wildcard, case-insensitive',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip0': 'Wildcard examples:',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip1': 'Path prefix: /hello/world/*',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip2': 'Path suffix: */hello/world',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip3': 'Containing path: */article/*',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip4':
    'All URLs under a domain: *.example.com/*',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip5': 'Ignore extension: *.js',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.1': 'Common Images',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.2': 'Common Videos',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.4': 'Common Audio',
  //v1.3.2
  'cdnResources.detail.tabKey9.title1': 'Page optimization',
  'cdnResources.detail.tabKey9.title2': 'Content compression',
  'cdnResources.detail.tabKey9.title3': 'Cache optimization',
  'cdnResources.detail.tabKey9.PageOptimize.title': 'Static file optimization',
  'cdnResources.detail.tabKey9.PageOptimize.name1': 'HTML optimization',
  'cdnResources.detail.tabKey9.PageOptimize.name2': 'Javascript optimization',
  'cdnResources.detail.tabKey9.PageOptimize.name3': 'CSS optimization',
  'cdnResources.detail.tabKey9.PageOptimize.name1.p':
    'It can automatically optimize the whitespace, comments, empty tags, etc. contained in HTML; Only files that can be cached will be optimized.',
  'cdnResources.detail.tabKey9.PageOptimize.name2.p':
    'It can automatically shorten variables, function names, etc. in Javascript. Only files that can be cached will be optimized.',
  'cdnResources.detail.tabKey9.PageOptimize.name3.p':
    'It can automatically remove the whitespace contained in CSS. Only files that can be cached will be optimized.',
  'cdnResources.detail.tabKey9.GzipOptimize.title1': 'Compression algorithm',
  'cdnResources.detail.tabKey9.GzipOptimize.title2': 'Image algorithm',
  'cdnResources.detail.tabKey9.GzipOptimize.name1': 'Compression enabled',
  'cdnResources.detail.tabKey9.GzipOptimize.name2': 'WebP',
  'cdnResources.detail.tabKey9.GzipOptimize.name1.p':
    'A fast compression algorithm that supports high compression rates and real-time compression performance. The priority of compression algorithms is arranged in chronological order.',
  'cdnResources.detail.tabKey9.GzipOptimize.name2.p':
    'Select to enable automatic WebP compression; The width and height of the image cannot exceed 16383 px; Only cached image content will be converted; The minimum cache time is 7200 seconds.',
  'cdnResources.detail.tabKey9.CacheOptimize.title': 'Cache condition optimization',
  'cdnResources.detail.tabKey9.CacheOptimize.name1': 'Ignore parameters',
  'cdnResources.detail.tabKey9.CacheOptimize.name1.p1':
    'After activation, the generated cache key does not include the URI parameter, which is the content after the question mark (?).',
  'cdnResources.detail.tabKey9.CacheOptimize.name1.p2':
    ' For more information, please refer to the document →',
};
